import React, { useEffect, useContext, useState } from 'react'
import PropTypes from 'prop-types'
import { ClearOutlined } from '@material-ui/icons'
import myContext from '../../PropertySearch/FiltersComponent/context/context'
import '../../../Components/PropertySearch/FiltersComponent/AddedStyles.css'
// import CloseIcon from '@material-ui/icons/Close'

const Alert = props => {

    const { config } = props

    // console.log(config.message)
    const [show, setShow] = useState(false)
    const { showAlert, setShowAlert } = useContext(myContext)

    const customStyles = {
        'visibility': 'hidden',
        'position': 'fixed',
        // 'z-index': '9999',
        'zIndex': '9999',
        'left': '50%',
        // if bottom percent is changed, update it in .fadein-Snackbar .fadeout-Snackbar
        'top': '2%',
        'transform': 'translateX(-50%)',
    }

    useEffect(() => {
        if (showAlert) {
            setShow(true)
            setTimeout(function () {
                setShowAlert(false)
                setShow(false)
            }, config.duration ? config.duration : 5000)
        }

        return () => {
            setShow(false)
        }

    }, [showAlert])

    const getAlertTypeClass = () => {
        let returnVal = ''

        switch (config.type) {
            case 'primary':
                returnVal = 'bg-primary'
                break
            case 'error':
                returnVal = 'bg-danger'
                break
            case 'success':
                returnVal = 'bg-success'
                break
            case 'warning':
                returnVal = 'bg-warning'
                break
            default: break
        }

        return returnVal
    }

    const closeAlert = () => {
        setShowAlert(false)
    }

    return (
        <>
            <div data-testid="test-div-alert" style={customStyles} className={`items-center align-middle ${show ? 'show-Snackbar' : ''}`} >
                <div className={`flex items-center py-3 px-6 shadow-md mb-2 ${getAlertTypeClass()}`}>
                    <div className="text-white max-w-xs ">
                        {config.message}
                    </div>
                    <div className='pl-4'>
                        <a className='text-white cursor-pointer color-black' data-testid="test-close-alert"
                            onClick={closeAlert}>
                            <ClearOutlined fontSize="small" />
                        </a>
                    </div>
                </div>

            </div>
        </>
    )
}

export default Alert

Alert.propTypes = {
    config: PropTypes.any
}
